import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7408f336"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "show" }
const _hoisted_2 = { style: {"color":"#1DA57A"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " | ", -1))

import { computed } from 'vue';
import {TextFieldType} from '@/components/business/crud/interface/FieldType';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer";


export default /*#__PURE__*/_defineComponent({
  __name: 'TimeTableField',
  props: {
    propName: {},
    widget: {},
    info: {},
    data: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(props.data.username), 1),
    _hoisted_3,
    _createElementVNode("span", null, _toDisplayString(props.data.typeText) + "://" + _toDisplayString(props.data.host) + ":" + _toDisplayString(props.data.port), 1)
  ]))
}
}

})